<template>
  <b-modal ref="modal" :title="this.$t('permissions')" size="xl" @ok="okClicked">
    <p>
      {{ $t('choose-services-to-giving-permission') }}
    </p>
    <service-picker v-model="form.serviceIds" :services="services" />
    <b-form-group :label="this.$t('access-control')" class="mt-3">
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="form.accessControl"
        :options="options"
        name="access-control"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ServicePicker from '@/components/inputs/ServicePicker.vue';

export default {
  name: 'ServicePermissionsModalAddForm',
  props: {
    permissions: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null,
    },
  },
  data() {
    return {
      form: {
        serviceIds: null,
        accessControl: null,
      },
      options: [
        { value: 'status', text: 'Status' },
        { value: 'control', text: 'Control' },
        { value: 'settings', text: 'Settings' },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getServices',
    ]),
    services() {
      if (this.permissions) {
        const assignedServiceIds = this.permissions.map(permission => permission.service);
        return this.getServices.filter(
          service => !this.$_.includes(assignedServiceIds, service.id),
        );
      }
      return this.getServices;
    },
  },
  methods: {
    ...mapActions([
      'addSpaceplan',
    ]),
    okClicked() {
      this.$emit('service-picked', {
        serviceIds: this.form.serviceIds,
        accessControl: this.form.accessControl,
      });
      this.form.serviceIds = null;
      this.form.accessControl = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  components: {
    ServicePicker,
  },
};
</script>

<style scoped>

</style>
